import { Link } from 'react-router';

const CustomLink = ({ href, ...props }: any) => (
  <Link to={href} {...props} viewTransition prefetch="intent" />
);

export default CustomLink;
